// https://developer.chrome.com/articles/page-lifecycle-api/

import _ from "lodash";

export enum PageState {
    Active = 'active',
    Passive = 'passive',
    Hidden = 'hidden',
}

function getState() {
  if (document.visibilityState === PageState.Hidden) {
    return PageState.Hidden;
  }
  if (document.hasFocus()) {
    return PageState.Active;
  }
  return PageState.Passive;
}

type Subscriber = (isActivate: boolean) => void;

export class WatchDog {
    onEmitChance: () => void;
    constructor() {
        this.onEmitChance = _.debounce(this._onEmitChance.bind(this), 500, {leading: false, trailing: true})
    }

    allowedEmitStates = [PageState.Active]

    static intervalTime = 1000 * 60 * 2;

    subscribers = new Set<Subscriber>();

    subscribe(callback: Subscriber) {
        this.subscribers.add(callback);

        // 如果是第一个订阅者，启动
        if (this.subscribers.size === 1) {
            this.startListen();
        }

        // 返回一个取消订阅的函数
        return () => {
            this.subscribers.delete(callback);

            // 如果没有订阅者了，停止emit
            if (this.subscribers.size === 0) {
                this.stopListen();
                this.stopInterval();
            }
        };
    }
    static interval?: any = undefined;
    private startInterval() {
        if(!WatchDog.interval) {
            WatchDog.interval = setInterval(() => {
                this.callSubscribers(true);
            }, WatchDog.intervalTime);
            this.callSubscribers(true);
        }
    }
    private stopInterval() {
        if (WatchDog.interval !== undefined) {
            clearInterval(WatchDog.interval);
            WatchDog.interval = undefined;
            this.callSubscribers(false);
        }
    }
    private callSubscribers(isActivate:boolean) {
        this.subscribers.forEach(sub => sub(isActivate));
    }
    private _onEmitChance() {
        const state = getState();
        if(this.allowedEmitStates.includes(state)) {
            this.startInterval();
        }else {
            this.stopInterval();
        }
    }


    private _listenTypes = ['pageshow', 'focus', 'blur', 'visibilitychange', 'resume']
    private startListen() {
        this.stopListen();
        this._listenTypes.forEach((type) => {
          window.addEventListener(type, this.onEmitChance);
        });
    }
    private stopListen() {
        this._listenTypes.forEach((type) => {
            window.removeEventListener(type, this.onEmitChance);
        })
    }
}

export const watchDog = new WatchDog();

